/**
 * Best-effort client-side error reporting.
 *
 * Shared by the top-level and per-route error boundaries so the fire-and-forget
 * POST to `/frontend-errors` lives in exactly one place (DRY). Never throws —
 * a failed report must not trigger another error and loop.
 */
export interface ClientErrorReport {
  message: string
  stack?: string
  componentStack?: string | null
  /** Which boundary/source captured the error (e.g. "RouteErrorBoundary"). */
  source?: string
}

export function reportClientError(report: ClientErrorReport): void {
  const apiBase = import.meta.env.VITE_API_BASE ?? ""
  // eslint-disable-next-line no-console -- intentional: surface in dev consoles
  console.error(`[${report.source ?? "ErrorBoundary"}]`, report.message, report.stack)
  fetch(`${apiBase}/frontend-errors`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...report,
      url: window.location.href,
      timestamp: new Date().toISOString(),
    }),
  }).catch(() => {
    /* swallow — don't cause infinite error loops */
  })
}
